var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.869,
    height: 41.224,
    viewBox: "0 0 42.869 41.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "programming",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21923",
    "data-name": "Path 21923",
    d: "M10.574,45.224H36.295c4.728,0,8.574-4.623,8.574-10.306V14.306C44.869,8.623,41.022,4,36.295,4H10.574C5.846,4,2,8.623,2,14.306V34.918C2,40.6,5.846,45.224,10.574,45.224Zm0-36.071H36.295c2.364,0,4.287,2.311,4.287,5.153H6.287C6.287,11.464,8.21,9.153,10.574,9.153ZM6.287,19.459H40.582V34.918c0,2.842-1.923,5.153-4.287,5.153H10.574c-2.364,0-4.287-2.311-4.287-5.153Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21924",
    "data-name": "Path 21924",
    d: "M11.915,23.233A2.143,2.143,0,1,0,14.946,20.2L12.174,17.43l2.771-2.771a2.143,2.143,0,0,0-3.031-3.031L7.628,15.915a2.143,2.143,0,0,0,0,3.031Zm8.574,0a2.142,2.142,0,0,0,3.031,0l4.287-4.287a2.143,2.143,0,0,0,0-3.031l-4.287-4.287a2.143,2.143,0,0,0-3.031,3.031L23.26,17.43,20.488,20.2A2.142,2.142,0,0,0,20.489,23.233Z",
    transform: "translate(5.717 12.854)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/backend.fe5bb5b22e83c24e0a9f7221257415ab.svg";
export { ForwardRef as ReactComponent };